export default {
  boundClaims: {
    date_one: null,
    date_two: null,
    id: null,
    amount_one: null,
    amount_two: null,
    select_one: null,
    select_two: null,
  },
  boundEng: {
    status: '',
    business: '',
    underwriter: '',
    awAnalist1: '',
    awAnalist2: '',
    underwriterMonth: '',
    cedentCompany: '',
    operatingCompany: '',
    typeBound: '',
    leader: '',
    term: '',
    rationalComments: '',
    riskProfileComments: '',
    riskProfileClause: '',
    riskProfileExposure: '',
    riskProfileHousekeeping: '',
    instalation1: null,
    instalation2: null,
    instalation3: null,
    clause1: null,
    clause2: null,
    clause3: null,
    ppw1: '',
    ppw2: '',
    ppw3: '',
  },
  boundInsurable: {
    rate: '',
    nd: '',
    premiumTiv: '',
    alopCurrency: '',
    alopCurrencyUsd: '',
    alopCurrencyRate: '',
    alopCurrencyNd: '',
    alopCurrencyPremium: '',
    totalRate: '',
    totalNd: '',
    totalPremium: '',
    typeSelect: '',
    sluLine: '',
    sluExposure: '',
    sluPremium: '',
    pml: '',
    resultPml: '',
    comments: '',
  },
  boundInsurableProp: {
    limitedInsured: '',
    limitedInsuredUsd: '',
    typeSelect: '',
    attachPoint: '',
    attachPointUsd: '',
    sluLine: '',
    sluExposure: '',
    sluPremium: '',
    applySirSelect: '',
    selfInsured: '',
  },
  boundEngCatDeductibles: [
    {
      id: '',
      location: '',
      underlyingCatSelect: '',
      underlyingCatAplicaSelect: '',
      underlyingCatValuesSelect: '',
      underlyingCatValuesSelectTwo: '',
      underlyingHidroSelect: '',
      underlyingHidroAplicaSelect: '',
      underlyingHidroValuesSelect: '',
      underlyingHidroValuesSelectTwo: '',
      coverB: null,
      coverTwoB: null,
      hidroRisk: null,
      hidroRiskTwo: null,
      alopEarthquake: null,
      alopHidro: null,
    },
  ],
  boundPropDeductibles: [
    {
      id: '',
      location: '',
      underlyingCatSelect: '',
      underlyingCatAplicaSelect: '',
      underlyingCatValuesSelect: '',
      underlyingCatValuesSelectTwo: '',
      underlyingHidroSelect: '',
      underlyingHidroAplicaSelect: '',
      underlyingHidroValuesSelect: '',
      underlyingHidroValuesSelectTwo: '',
      coverB: null,
      coverTwoB: null,
      hidroRisk: null,
      hidroRiskTwo: null,
      alopEarthquake: null,
      alopHidro: null,
    },
  ],
  boundEngDeductibles: [
    {
      id: '',
      underlyingFireSelect: '',
      underlyingFireNumberSelect: '',
      underlyingFireAplicaSelect: '',
      underlyingFireValuesSelect: '',
      underlyingFireAmount: '',
      underlyingFireValuesSelectTwo: '',
      underlyingFireAmountTwo: '',
      underlyingFireText: '',
      search: '',
      deductibleId: '',
    },
  ],
  boundSublimes: {
    id: '',
    sublimits1: '',
    sublimits2: '',
    sublimitsValue1: '',
    sublimitsValue2: '',
    location: '',
  },
  boundSublimesProp: [
    {
      id: '',
      sublimits1: '',
      sublimits2: '',
      sublimitsValue1: '',
      sublimitsValue2: '',
      location: '',
    },
  ],
  boundSublimitsEng: [
    {
      id: '',
      endosoSelect: '',
      endosoText: '',
      endosoUsd: '',
    },
  ],
  boundSublimitsProp: [
    {
      id: '',
      otherDeductiblesSelect: '',
      otherDeductiblesValue: '',
      otherDeductiblesValueUsd: '',
    },
  ],
  boundPml: {
    pmlDamage: '',
    pmlBi: '',
    pmlStocks: '',
    pmlDamageUsd: '',
    pmlBiUsd: '',
    pmlStocksUsd: '',
    pmlComments: '',
    pmlTotal: '',
    pmlTotalUsd: '',
  },
  mliv: {
    damage: '',
    bi: '',
    stocks: '',
    damageUsd: '',
    biUsd: '',
    stocksUsd: '',
    total: '',
    totalUsd: '',
  },
  tivBound: [{ limitedInsured: null, limitedInsuredUSD: null, typeSelect: '' }],
  operatingEng: [
    {
      id: 1,
      country: 'Argentina',
      cedingCompany: 'AIG Seguros Mexico. S.A.',
    },
    {
      id: 2,
      country: 'Argentina',
      cedingCompany: 'Federacion Patronal',
    },
    {
      id: 3,
      country: 'Argentina',
      cedingCompany: 'Mercado Libre S.R.L',
    },
    {
      id: 4,
      country: 'Argentina',
      cedingCompany: 'Nacion Seguros S.A.',
    },
    {
      id: 5,
      country: 'Argentina',
      cedingCompany: 'National seguros S.A.',
    },
    {
      id: 6,
      country: 'Argentina',
      cedingCompany: 'Sancor Cooperativa de Seguros Limitada',
    },
    {
      id: 7,
      country: 'Argentina',
      cedingCompany: 'Sancor Cooperativa de Seguros Ltda.',
    },
    {
      id: 8,
      country: 'Argentina',
      cedingCompany: 'Sancor Seguros',
    },
    {
      id: 9,
      country: 'Argentina',
      cedingCompany: 'Seguros Sura',
    },
    {
      id: 10,
      country: 'Argentina',
      cedingCompany: 'Zurich Insurance Company Ltd',
    },
    {
      id: 11,
      country: 'Bahamas',
      cedingCompany: 'Royal Star Assurence',
    },
    {
      id: 12,
      country: 'Bahamas',
      cedingCompany: 'RoyalStar Assurance Limited',
    },
    {
      id: 13,
      country: 'Bolivia',
      cedingCompany: 'Unibienes S.A.',
    },
    {
      id: 14,
      country: 'Brazil',
      cedingCompany: 'Starr International Brasil Seguradora S.A',
    },
    {
      id: 15,
      country: 'Caiman Island',
      cedingCompany: 'Royal Star Assurance Ltd',
    },
    {
      id: 16,
      country: 'Caiman Island',
      cedingCompany: 'Royal Star Assurance Ltd.',
    },
    {
      id: 17,
      country: 'Cayman Islands',
      cedingCompany: 'Royal Star Assurance Ltd',
    },
    {
      id: 18,
      country: 'Chile',
      cedingCompany: 'Compañía de Reaseguros, S.A.',
    },
    {
      id: 19,
      country: 'Chile',
      cedingCompany: 'BCI Sefuros Chile',
    },
    {
      id: 20,
      country: 'Chile',
      cedingCompany: 'Chubb (Chile)',
    },
    {
      id: 21,
      country: 'Chile',
      cedingCompany: 'Chubb Chile',
    },
    {
      id: 22,
      country: 'Chile',
      cedingCompany: 'Compania de Seguros Generales Continental',
    },
    {
      id: 23,
      country: 'Chile',
      cedingCompany: 'Lloyd’s Syndicate CVS 1919',
    },
    {
      id: 24,
      country: 'Chile',
      cedingCompany: 'Mapfre Compania de Seguros Generales de Chile',
    },
    {
      id: 25,
      country: 'Chile',
      cedingCompany: 'Mapfre de Compania Reaseguro S.A.',
    },
    {
      id: 26,
      country: 'Chile',
      cedingCompany: 'Mapfre Global Risks',
    },
    {
      id: 27,
      country: 'Chile',
      cedingCompany: 'MAPFRE RE, Compañía de Reaseguros, S.A.',
    },
    {
      id: 28,
      country: 'Chile',
      cedingCompany: 'Mapfre Seguros Generales S.A',
    },
    {
      id: 29,
      country: 'Chile',
      cedingCompany: 'Renta Nacional',
    },
    {
      id: 30,
      country: 'Chile',
      cedingCompany: 'RSA Espana',
    },
    {
      id: 31,
      country: 'Chile',
      cedingCompany: 'Scor',
    },
    {
      id: 32,
      country: 'Chile',
      cedingCompany: 'Seguros Generales Suramericana S.A',
    },
    {
      id: 33,
      country: 'Chile',
      cedingCompany: 'Sura Chile',
    },
    {
      id: 34,
      country: 'Colombia',
      cedingCompany: 'Aseguradora Solidaria de Colombia',
    },
    {
      id: 35,
      country: 'Colombia',
      cedingCompany: 'Aseguradora Solidaria deColombia S.A',
    },
    {
      id: 36,
      country: 'Colombia',
      cedingCompany: 'Axa Colombia',
    },
    {
      id: 37,
      country: 'Colombia',
      cedingCompany: 'AXA Colpatria',
    },
    {
      id: 38,
      country: 'Colombia',
      cedingCompany: 'Axa Colpatria',
    },
    {
      id: 39,
      country: 'Colombia',
      cedingCompany: 'Black Gold Re',
    },
    {
      id: 40,
      country: 'Colombia',
      cedingCompany: 'Instituto Nacional de Seguros',
    },
    {
      id: 41,
      country: 'Colombia',
      cedingCompany: 'La Previsora Compania de Seguros S.A.',
    },
    {
      id: 42,
      country: 'Colombia',
      cedingCompany: 'Mapfre Seguros Colombia S.A',
    },
    {
      id: 43,
      country: 'Colombia',
      cedingCompany: 'Rokstone',
    },
    {
      id: 44,
      country: 'Colombia',
      cedingCompany: 'SBS Seguros Colombia',
    },
    {
      id: 45,
      country: 'Colombia',
      cedingCompany: 'Scor',
    },
    {
      id: 46,
      country: 'Costa Rica',
      cedingCompany: 'Instituto Nacional de Seguros',
    },
    {
      id: 47,
      country: 'Costa Rica',
      cedingCompany: 'Instituto Nacional de Seguros',
    },
    {
      id: 48,
      country: 'Costa Rica',
      cedingCompany: 'Lafise Seguros',
    },
    {
      id: 49,
      country: 'Costa Rica',
      cedingCompany: 'Mapfre Seguros',
    },
    {
      id: 50,
      country: 'Costa Rica',
      cedingCompany: 'Seguros Banorte',
    },
    {
      id: 51,
      country: 'Costa Rica',
      cedingCompany: 'Seguros La Colonial',
    },
    {
      id: 52,
      country: 'Curaçao',
      cedingCompany: 'Massy United Insurance',
    },
    {
      id: 53,
      country: 'Dominican Republic',
      cedingCompany: 'General de Seguros',
    },
    {
      id: 54,
      country: 'Dominican Republic',
      cedingCompany: 'La Colonial de Seguros',
    },
    {
      id: 55,
      country: 'Dominican Republic',
      cedingCompany: 'Mapfre',
    },
    {
      id: 56,
      country: 'Dominican Republic',
      cedingCompany: 'Mapfre BHD Seguros',
    },
    {
      id: 57,
      country: 'Dominican Republic',
      cedingCompany: 'Seguros Reservas S.A.',
    },
    {
      id: 58,
      country: 'Dominican Republic',
      cedingCompany: 'Seguros Sura, S.A.',
    },
    {
      id: 59,
      country: 'Dominican Republic',
      cedingCompany: 'Seguros Universal',
    },
    {
      id: 60,
      country: 'Ecuador',
      cedingCompany: 'Compañia de Seguros Ecuatoriano Suiza S.A',
    },
    {
      id: 61,
      country: 'Ecuador',
      cedingCompany: 'Ecuasuiza de Ecuador',
    },
    {
      id: 62,
      country: 'Ecuador',
      cedingCompany: 'Ecuatoriano Suiza',
    },
    {
      id: 63,
      country: 'Ecuador',
      cedingCompany: 'Ecuatoriano Suiza Compania de Seguros',
    },
    {
      id: 64,
      country: 'Ecuador',
      cedingCompany: 'Hispana de Seguros S.A',
    },
    {
      id: 65,
      country: 'Ecuador',
      cedingCompany: 'Interoceanica',
    },
    {
      id: 66,
      country: 'Ecuador',
      cedingCompany: 'Seguros Equinoccial',
    },
    {
      id: 67,
      country: 'Ecuador',
      cedingCompany: 'Seguros Sucre S.A',
    },
    {
      id: 68,
      country: 'Ecuador',
      cedingCompany: 'Seguros Sucre S.A.',
    },
    {
      id: 69,
      country: 'El Salvador',
      cedingCompany: 'Aseguradora Agrícola Comercial',
    },
    {
      id: 70,
      country: 'El Salvador',
      cedingCompany: 'Aseguradora Agricola Comercial',
    },
    {
      id: 71,
      country: 'El Salvador',
      cedingCompany: 'Aseguradora Agricola Comercial, S.A',
    },
    {
      id: 72,
      country: 'El Salvador',
      cedingCompany: 'Aseguradora Agrícola Comercial, S.A. (ACSA)',
    },
    {
      id: 73,
      country: 'El Salvador',
      cedingCompany: 'Internacional de Seguros',
    },
    {
      id: 74,
      country: 'El Salvador',
      cedingCompany: 'Seguros e inversiones S.A.',
    },
    {
      id: 75,
      country: 'Grenada',
      cedingCompany: 'Massy United Insurance Company',
    },
    {
      id: 76,
      country: 'Guatemala',
      cedingCompany: 'Banco Hipotecario Nacional (CHN)',
    },
    {
      id: 77,
      country: 'Guatemala',
      cedingCompany: 'Ficohsa Guatemala',
    },
    {
      id: 78,
      country: 'Guatemala',
      cedingCompany: 'Mapfre Global Risks',
    },
    {
      id: 79,
      country: 'Guatemala',
      cedingCompany: 'Seguros Agromercantil',
    },
    {
      id: 80,
      country: 'Guatemala',
      cedingCompany: 'Seguros Agromercantil S.A',
    },
    {
      id: 81,
      country: 'Guatemala',
      cedingCompany: 'Seguros Agromercantil, S.A.',
    },
    {
      id: 82,
      country: 'Guatemala',
      cedingCompany: 'Seguros el Roble',
    },
    {
      id: 83,
      country: 'Guatemala',
      cedingCompany: 'Seguros El Roble',
    },
    {
      id: 84,
      country: 'Guatemala',
      cedingCompany: 'Seguros el Roble S.A.',
    },
    {
      id: 85,
      country: 'Guatemala',
      cedingCompany: 'Seguros El Roble, Guatemala',
    },
    {
      id: 86,
      country: 'Guatemala',
      cedingCompany: 'Seguros G&T S.A',
    },
    {
      id: 87,
      country: 'Guatemala',
      cedingCompany: 'Seguros GyT',
    },
    {
      id: 88,
      country: 'Guatemala',
      cedingCompany: 'Seguros GyT Guatemala',
    },
    {
      id: 89,
      country: 'Haiti',
      cedingCompany: 'Alternative Insurance Company (AIC)',
    },
    {
      id: 90,
      country: 'Haiti',
      cedingCompany: 'Mangrove Insrance Solutions pcc',
    },
    {
      id: 91,
      country: 'Honduras',
      cedingCompany: 'Crefisa S.A.',
    },
    {
      id: 92,
      country: 'Honduras',
      cedingCompany: 'Ficohsa Seguros',
    },
    {
      id: 93,
      country: 'Honduras',
      cedingCompany: 'Ficohsa Seguros Honduras',
    },
    {
      id: 94,
      country: 'Honduras',
      cedingCompany: 'Seguros Crefisa - Honduras',
    },
    {
      id: 95,
      country: 'Honduras',
      cedingCompany: 'Seguros GyT Guatemala',
    },
    {
      id: 96,
      country: 'Honduras',
      cedingCompany: 'Seguros Lafise S.A',
    },
    {
      id: 97,
      country: 'Jamaica',
      cedingCompany: 'British Caribbean Insurance Company',
    },
    {
      id: 98,
      country: 'Jamaica',
      cedingCompany: 'General Accident Insurance Company',
    },
    {
      id: 99,
      country: 'Jamaica',
      cedingCompany: 'General Accident Insurance Company Jamaica Ltd',
    },
    {
      id: 100,
      country: 'Mexico',
      cedingCompany: 'Agroasemex',
    },
    {
      id: 101,
      country: 'Mexico',
      cedingCompany: 'Agroasemex S.A',
    },
    {
      id: 102,
      country: 'Mexico',
      cedingCompany: 'Axa Mexico',
    },
    {
      id: 103,
      country: 'Mexico',
      cedingCompany: 'Best Meridian International Insurance Company',
    },
    {
      id: 104,
      country: 'Mexico',
      cedingCompany: 'Cancelled',
    },
    {
      id: 105,
      country: 'Mexico',
      cedingCompany: 'Grupo Mexicano de Seguros',
    },
    {
      id: 106,
      country: 'Mexico',
      cedingCompany: 'Grupo Mexicano De Seguros, S. A. De C.V.',
    },
    {
      id: 107,
      country: 'Mexico',
      cedingCompany: 'Grupo Mexicano de Seguros, S.A',
    },
    {
      id: 108,
      country: 'Mexico',
      cedingCompany: 'Grupo Nacional Provincial',
    },
    {
      id: 109,
      country: 'Mexico',
      cedingCompany: 'Grupo Nacional Provincial S.A.B',
    },
    {
      id: 110,
      country: 'Mexico',
      cedingCompany: 'Insurance Company of the Bahamas Limited',
    },
    {
      id: 111,
      country: 'Mexico',
      cedingCompany: 'Mapfre Re Compañía de Reaseguros',
    },
    {
      id: 112,
      country: 'Mexico',
      cedingCompany: 'Seguros Afirme',
    },
    {
      id: 113,
      country: 'Mexico',
      cedingCompany: 'Seguros Afirme, S.A',
    },
    {
      id: 114,
      country: 'Mexico',
      cedingCompany: 'Seguros Afirme, S.A de C.V, AFIRME Grupo Financiero',
    },
    {
      id: 115,
      country: 'Mexico',
      cedingCompany: 'Seguros Atlas',
    },
    {
      id: 116,
      country: 'Mexico',
      cedingCompany: 'Seguros Atlas S.A',
    },
    {
      id: 117,
      country: 'Mexico',
      cedingCompany: 'Seguros Atlas, S.A',
    },
    {
      id: 118,
      country: 'Mexico',
      cedingCompany: 'Seguros Atlas, S.A.',
    },
    {
      id: 119,
      country: 'Mexico',
      cedingCompany: 'Seguros Azteca',
    },
    {
      id: 120,
      country: 'Mexico',
      cedingCompany: 'Seguros Banorte',
    },
    {
      id: 121,
      country: 'Mexico',
      cedingCompany: 'Seguros Banorte S.A.',
    },
    {
      id: 122,
      country: 'Mexico',
      cedingCompany: 'Seguros Banorte, S.A.',
    },
    {
      id: 123,
      country: 'Mexico',
      cedingCompany: 'Seguros Inbursa',
    },
    {
      id: 124,
      country: 'Mexico',
      cedingCompany: 'Seguros Inbursa S.A.',
    },
    {
      id: 125,
      country: 'Mexico',
      cedingCompany: 'Zurich Insurance Company LTD.',
    },
    {
      id: 126,
      country: 'Nicaragua',
      cedingCompany: 'Instituto Nicaraguense de Seguros - Iniser',
    },
    {
      id: 127,
      country: 'Nicaragua',
      cedingCompany: 'Seguros America',
    },
    {
      id: 128,
      country: 'Nicaragua',
      cedingCompany: 'Seguros America (Nicaragua)',
    },
    {
      id: 129,
      country: 'Panama',
      cedingCompany: 'Internacional de Seguros',
    },
    {
      id: 130,
      country: 'Panama',
      cedingCompany: 'Aliado Seguros',
    },
    {
      id: 131,
      country: 'Panama',
      cedingCompany: 'Bagatrac S.A.',
    },
    {
      id: 132,
      country: 'Panama',
      cedingCompany: 'Internacional de Seguros',
    },
    {
      id: 133,
      country: 'Panama',
      cedingCompany: 'Mapfre Panama',
    },
    {
      id: 134,
      country: 'Paraguay',
      cedingCompany: 'Royal Seguros S.A',
    },
    {
      id: 135,
      country: 'Peru',
      cedingCompany: 'Banco Financiero -Banbif',
    },
    {
      id: 136,
      country: 'Peru',
      cedingCompany: 'Chubb Seguros Peru',
    },
    {
      id: 137,
      country: 'Peru',
      cedingCompany: 'La Positiva',
    },
    {
      id: 138,
      country: 'Peru',
      cedingCompany: 'La Positiva Peru',
    },
    {
      id: 139,
      country: 'Peru',
      cedingCompany: 'La Positiva Seguros',
    },
    {
      id: 140,
      country: 'Peru',
      cedingCompany: 'La Positiva Seguros y Reaseguros',
    },
    {
      id: 141,
      country: 'Peru',
      cedingCompany: 'La Positiva Seguros Y Reaseguros S.A.',
    },
    {
      id: 142,
      country: 'Peru',
      cedingCompany: 'Mafre Peru S.A',
    },
    {
      id: 143,
      country: 'Peru',
      cedingCompany: 'Mapfre Global Risks',
    },
    {
      id: 144,
      country: 'Peru',
      cedingCompany: 'Pacifico Seguros y Reaseguros',
    },
    {
      id: 145,
      country: 'Peru',
      cedingCompany: 'Rimac',
    },
    {
      id: 146,
      country: 'Peru',
      cedingCompany: 'Rimac Internacional Compañía de Seguros y Reaseguros',
    },
    {
      id: 147,
      country: 'Peru',
      cedingCompany: 'Rímac Internacional Compañía de Seguros y Reaseguros',
    },
    {
      id: 148,
      country: 'Peru',
      cedingCompany: 'Rimac Seguros',
    },
    {
      id: 149,
      country: 'Peru',
      cedingCompany: 'Rimac Seguros Compañia de Seguros y Reaseguros',
    },
    {
      id: 150,
      country: 'Peru',
      cedingCompany: 'Rimac seguros y reaseguros',
    },
    {
      id: 151,
      country: 'Peru',
      cedingCompany: 'Rimac Segurosy Reaseguros',
    },
    {
      id: 152,
      country: 'RepublicaDominicana',
      cedingCompany: 'Dominican Republic Locations - Seguros Universal',
    },
    {
      id: 153,
      country: 'RepublicaDominicana',
      cedingCompany: 'La Colonial, S.A.',
    },
    {
      id: 154,
      country: 'RepublicaDominicana',
      cedingCompany: 'Seguros Universal',
    },
    {
      id: 155,
      country: 'Trinidad',
      cedingCompany: 'Sagicor Insurance Company Limited',
    },
    {
      id: 156,
      country: 'Trinidad',
      cedingCompany: 'Guardian General Insurance Company',
    },
    {
      id: 157,
      country: 'Trinidad',
      cedingCompany: 'Sagicor Insurance Company Limited',
    },
    {
      id: 158,
      country: 'Virgin Islands',
      cedingCompany: 'Island Heritage',
    },
  ],
  clause: [
    {
      id: 1,
      data: 'TOR 4/86',
    },
    {
      id: 2,
      data: 'LWS 3000',
    },
    {
      id: 3,
      data: 'LWS 3001',
    },
  ],
};
